module.exports = __webpack_public_path__ + "static/media/sample_lmtruckdetails.9eb3df2a.csv";